import { render, staticRenderFns } from "./OrderComponentWaitingList.vue?vue&type=template&id=d6769658&"
import script from "./OrderComponentWaitingList.vue?vue&type=script&lang=js&"
export * from "./OrderComponentWaitingList.vue?vue&type=script&lang=js&"
import style0 from "./OrderComponentWaitingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports